import Vue from 'vue';
import VueRouter from 'vue-router'

// Route Components
import Home from '../views/Home.vue';

// Middleware
import checkAuth from './middleware/checkauth';

const routes = [
    { 
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            middleware: checkAuth
        }
    },
    {
        path: '/logincallback',
        name: 'logincallback',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/logout', redirect: { name: 'home' }
    }
]


Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    base: '/',
    routes
});
